import { render, staticRenderFns } from "./PsiDetailSubscriptions.vue?vue&type=template&id=003d2d94"
import script from "./PsiDetailSubscriptions.vue?vue&type=script&lang=js"
export * from "./PsiDetailSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports